import React, { useEffect, useMemo, useState } from "react";
import Form from "../utils/Form";
import { useDispatch, useSelector } from "react-redux";
import { all_language_list } from "../../actions/Masters/language";
import { useLocation, useNavigate } from "react-router-dom";
// import { all_movie_list, audio_in_movie_update } from "../../actions/Movie/video";
import { bindActionCreators } from "redux";
import * as Action from "../../actions/Movie/video";

const VideoLinks = () => {
  const [form, setForm] = useState({});
  const [formStructure, setFormStructure] = useState([]);
  const message = useSelector((state) => state.layout.message);
  const user = useSelector((state) => state?.layout?.profile);

  const language = useSelector((state) => state.masters.languages);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { audio_in_movie_update, audio_in_movie_list } = bindActionCreators(
    Action,
    dispatch
  );

  useEffect(() => {
    if (language?.statuscode != 200) dispatch(all_language_list());
  }, []);
  // useMemo(() => {
  //   (async () => {
  //     if (location?.state?.movie_id) {
  //       setForm({ ...form, video_id: location?.state?.movie_id });
  //       const resData = await audio_in_movie_list({
  //         video_id: location?.state?.movie_id,
  //       });

  //       // setForm((prevForm) => ({ ...prevForm,   }));
  //       console.log(resData, "cheiiiioo");
  //     }
  //   })();
  // }, [location?.state?.movie_id]);

  // useMemo(() => {
  //   if (language?.statuscode === 200) {
  //     // Generate form fields dynamically
  //     const list = language?.data?.flatMap((ele, index) => [
  //       {
  //         id: "4",
  //         type: "inputBox",
  //         title: "Language",
  //         name: `audio_language_${index}`,
  //         //   options: ["English", "Hindi", "Gujarati"],
  //         //   required: true,
  //       },
  //       {
  //         id: "4",
  //         type: "inputBox",
  //         title: "Movie File",
  //         name: `audio_file_${index}`,
  //         endsWith: ".mp4",
  //         errorText: "File extension should be .mp4 only",
  //         //   options: ["English", "Hindi", "Gujarati"],
  //         //   required: true,
  //       },
  //     ]);

  //     // Create languageOption object using reduce
  //     const languageOption = language?.data?.reduce((acc, ele, index) => {
  //       acc[`audio_language_${index}`] = ele?.language_name || "";
  //       return acc;
  //     }, {});
  //     console.log(languageOption, "nndssss");

  //     // Batch state updates to avoid multiple re-renders
  //     setFormStructure([
  //       ...list,
  //       { id: "10", type: "button", title: "Submit" },
  //     ]);
  //     // setTimeout(() => {
  //       setForm((prevForm) => ({
  //         ...prevForm,
  //         ...languageOption,
  //         video_id: location?.state?.movie_id,
  //       }));
  //     // }, 1000);
  //   }
  // }, [language]);
  // useMemo(() => {
  //   (async () => {
  //     if (location?.state?.movie_id) {
  //       setForm((prevForm) => ({
  //         ...prevForm,
  //         video_id: location?.state?.movie_id,
  //       }));

  //       const resData = await audio_in_movie_list({
  //         video_id: location?.state?.movie_id,
  //       });

  //       if (resData?.data?.length > 0) {
  //         // Create an updated form object with matched audio files
  //         const updatedForm = { ...form };
  //         // setTimeout(() => {
  //           resData?.forEach((audio, index) => {
  //             const languageIndex = Object.entries(form)
  //               .find(
  //                 ([key, value]) =>
  //                   key.startsWith("audio_language_") &&
  //                   value === audio?.audio_language
  //               )?.[0]
  //               ?.split("_")[2];
  //               console.log(languageIndex , "newPaeeeeeeee")
  //             if (languageIndex !== undefined) {
  //               updatedForm[`audio_file_${languageIndex}`] = audio.audio_file;
  //             }
  //           });

  //           setForm((prevForm) => ({ ...prevForm, ...updatedForm }));
  //         // }, 1500);
  //       }
  //     }
  //   })();
  // }, [location?.state?.movie_id]);
  useMemo(() => {
    if (language?.statuscode === 200) {
      // Generate form fields dynamically
      const list = language?.data?.flatMap((ele, index) => [
        {
          id: "4",
          type: "inputBox",
          title: "Language",
          name: `audio_language_${index}`,
        },
        {
          id: "4",
          type: "inputBox",
          title: "Movie File",
          name: `audio_file_${index}`,
          endsWith: ".mp4",
          errorText: "File extension should be .mp4 only",
        },
      ]);
  
      // Create initial form data for languages
      const languageOption = language?.data?.reduce((acc, ele, index) => {
        acc[`audio_language_${index}`] = ele?.language_name || "";
        return acc;
      }, {});
  
      // Batch state updates to avoid unnecessary re-renders
      setFormStructure([...list, { id: "10", type: "button", title: "Submit" }]);
  
      // setTimeout(() => {
        setForm((prevForm) => ({
          ...prevForm,
          ...languageOption,
          video_id: location?.state?.movie_id,
        }));
      // }, 500);
    }
  }, [language]);
  
  // useMemo(() => {
  //   (async () => {
  //     if (location?.state?.movie_id) {
  //       setForm((prevForm) => ({ ...prevForm, video_id: location?.state?.movie_id }));
  
  //       const resData = await audio_in_movie_list({ video_id: location?.state?.movie_id });
        
  //       console.log(form,"chhhhhhhhhhhhhhhhh")
  //       if (resData?.data?.length > 0) {
  //         setForm((prevForm) => {
  //           const updatedForm = { ...prevForm };
  
  //           resData?.data?.forEach((audio) => {
  //             // Find the corresponding index where audio_language matches
  //             const matchedEntry = Object.entries(prevForm).find(
  //               ([key, value]) =>
  //                 key.startsWith("audio_language_") && value.trim().toLowerCase() === audio.audio_language.trim().toLowerCase()
  //             );
  //             console.log(matchedEntry ,"dfsdfsdfsdfds")
  //             if (matchedEntry) {
  //               const matchedIndex = matchedEntry[0].split("_")[2]; // Extract the index
  //               updatedForm[`audio_file_${matchedIndex}`] = audio.audio_file;
  //             }
  //           });
  
  //           return updatedForm;
  //         });
  //       }
  //     }
  //   })();
  // }, [location?.state?.movie_id]);
  useMemo(() => {
    (async () => {
      if (location?.state?.movie_id && language?.statuscode === 200) {
        setForm((prevForm) => ({ ...prevForm, video_id: location?.state?.movie_id }));
  
        const resData = await audio_in_movie_list({ video_id: location?.state?.movie_id });
  
        console.log("Before updating form:", resData?.data);
  
        if (resData?.data?.length > 0) {
          setForm((prevForm) => {
            const updatedForm = { ...prevForm };
  
            Object.entries(prevForm).forEach(([key, value]) => {
              if (key.startsWith("audio_language_")) {
                const matchedAudio = resData.data.find(
                  (audio) => audio.audio_language.trim().toLowerCase() === value.trim().toLowerCase()
                );
  
                if (matchedAudio) {
                  const index = key.split("_")[2]; // Extract index from audio_language_x
                  updatedForm[`audio_file_${index}`] = matchedAudio.audio_file;
                }
              }
            });
  
            console.log("Updated form:", updatedForm);
            return updatedForm;
          });
        }
      }
    })();
  }, [location?.state?.movie_id , language]);
  
  
  console.log(form,"chechForm123654")

  const handleSubmit = async () => {
    // console.log(form ,"sdsdsdsdsdsd")
    const resData = await audio_in_movie_update(form);
    if (resData?.statuscode == 200) {
      navigate("/Video/Video", { state: { view: "view_all" } });
    } else {
      setForm({ ...form });
    }
  };
  // useMemo(() => {
  //   if (message?.statuscode == 200) {
  //     // setIsEdit(false);
  //     // setForm({ status: "Active" });

  //     // setTimeout(() => {
  //     //   const data = new FormData();
  //     //   data.append("id", user?.id);
  //     //   dispatch(all_movie_list(data));
  //     // }, 900);

  //   } else {

  //   }
  // }, [message]);
  return (
    <Form
      formStructure={formStructure}
      handleSubmit={handleSubmit}
      formTitle={"Video Link"}
      key={"Form"}
      setForm={setForm}
      form={form}
      //   tableData={tableData}
      //   setTableData={setTableData}
      //   isEdit={isEdit}
      //   setIsEdit={setIsEdit}
    />
  );
};

export default VideoLinks;
